export class AccordionItem {
    /**
     * @type {HTMLElement}
     * @private
     */
    _domElm;

    /**
     * @type {Accordion}
     * @private
     */
    _parent;

    /**
     * @type {boolean}
     * @private
     */
    _open = false;

    /**
     * @type {HTMLElement}
     * @private
     */
    _titleElm;

    /**
     * @type {HTMLElement}
     * @private
     */
    _titleContent;

    get domElm () {
        return this._domElm;
    }

    set domElm (value) {
        this._domElm = value;
    }

    get parent () {
        return this._parent;
    }

    set parent (value) {
        this._parent = value;
    }

    get open () {
        return this._open;
    }

    set open (value) {
        this._open = value;

        if (value === true && this.parent.active !== this.domElm) {
            this.parent.active = this.domElm;
        }

        this.update();
    }

    get titleElm () {
        return this._titleElm;
    }

    set titleElm (value) {
        this._titleElm = value;
    }

    get contentElm () {
        return this._contentElm;
    }

    set contentElm (value) {
        this._contentElm = value;
    }

    /**
     * @param parent {Accordion}
     * @param domElm {Element}
     */
    constructor (parent, domElm) {
        this.parent = parent;
        this.domElm = domElm;

        this.titleElm = this.domElm.querySelector('.accordion-item__title');
        this.contentElm = this.domElm.querySelector('.accordion-item__content');

        this.init();
        this.addListeners();
    }

    init () {
        this.updateOpenHeight();
    }

    addListeners () {
        this.titleElm.addEventListener('click', (e) => {
            this.open = !this.open;
        });

        window.addEventListener('resize', (e) => {
            this.updateOpenHeight();
        });
    };

    updateOpenHeight () {
        this.domElm.style.setProperty('--max-height', this.contentElm.scrollHeight + 'px');
    }

    update () {
        if (this.contentElm) {
            if (this.open) {
                this.domElm.classList.add('open');
            } else {
                this.domElm.classList.remove('open');
            }
        }
    }
}
